﻿(function (document) {
  function getMaxHeightOfElements(selector) {
    const elements = document.querySelectorAll(selector);
    let maxHeight = 0;
    elements.forEach(function (element) {
      const elementHeight = element.offsetHeight;
      if (elementHeight > maxHeight) {
        maxHeight = elementHeight;
      }
    });
    return maxHeight;
  }

  function applyMarginToElement(element, topMargin, bottomMargin) {
    if (element) {
      element.style.marginTop = topMargin
        ? `${topMargin}px`
        : '';

      element.style.marginBottom = bottomMargin
        ? `${bottomMargin}px`
        : '';
    }
  }

  function updateSearchFlyoutMargins() {
    const searchFlyout = document.querySelector('.site-search-flyout');
    const siteMessageHeight = getMaxHeightOfElements('[data-site-message]');
    const cookieBannerHeight = getMaxHeightOfElements('[data-cookie-banner]');
    applyMarginToElement(searchFlyout, siteMessageHeight, cookieBannerHeight);
  }

  document.querySelectorAll('[data-search-menu-toggle]').forEach(function (element) {
    element.addEventListener('click', function (e) {
      e.preventDefault();
      const body = document.querySelector('body');
      body.dataset.searchMenu =
        body.dataset.searchMenu === 'open'
          ? 'closed'
          : 'open';

      updateSearchFlyoutMargins();

      if (body.dataset.searchMenu === 'open') {
        const isMobileView = window.innerWidth <= 1024;
        let searchInput;

        if (isMobileView) {
          searchInput = document.querySelector('input.site-mobile-search-flyout__searchControl.tt-input');
        } else {
          searchInput = document.querySelector('input.site-search-flyout__searchControl.tt-input');
        }

        if (searchInput) {
          searchInput.focus();
        }
      }
    });
  });

  document.addEventListener('cookieBannerClosed', function () {
    updateSearchFlyoutMargins(); // Update margins when the custom event is fired
  });
})(document);